import React from 'react';
import './GaugeChart.css';

interface GaugeChartProps {
  value: number; // 0-100
  label: string;
  color: 'green' | 'blue';
}

const GaugeChart: React.FC<GaugeChartProps> = ({ value, label, color }) => {
  // Semicírculo: 180 graus, circunferência = π * raio
  const radius = 50;
  const circumference = Math.PI * radius; // ~157
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="gauge-wrapper">
      <svg className="gauge" viewBox="0 0 140 80">
        {/* Background arc */}
        <path
          className="gauge-bg"
          d="M 20 70 A 50 50 0 0 1 120 70"
          fill="none"
          strokeWidth="12"
        />
        {/* Value arc */}
        <path
          className={`gauge-fill ${color}`}
          d="M 20 70 A 50 50 0 0 1 120 70"
          fill="none"
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="gauge-label">
        <div className="gauge-value">{value.toFixed(1)}%</div>
        <div className="gauge-title">{label}</div>
      </div>
    </div>
  );
};

export default GaugeChart;




